/* Shop the latest: pill tabs over one product slider (Fashion Nova). A tab's cards load
   the first time it is opened; "For You" uses the shopper's last viewed product when
   there is one. Cards get the theme's usual behaviours through window.theme.initCards. */
(function () {
  const RECENT_KEY = 'recto:recently-viewed';
  function lastViewed() {
    try {
      const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      const id = Array.isArray(list) && list.find((x) => /^\d+$/.test(String(x)));
      return id ? String(id) : null;
    } catch (_) { return null; }
  }
  function wake(host) {
    if (window.theme && window.theme.initCards) window.theme.initCards(host);
    host.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
  }
  async function load(host, url) {
    host.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!r.ok) return false;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const panel = doc.querySelector('[data-latest-panel]');
      if (!panel || !panel.querySelector('.card, [data-product-id]')) return false;
      panel.removeAttribute('data-partial');
      host.innerHTML = '';
      host.appendChild(panel);
      wake(host);
      return true;
    } catch (_) { return false; } finally { host.removeAttribute('aria-busy'); }
  }
  function init(root) {
    if (root.dataset.latestReady) return;
    root.dataset.latestReady = '1';
    const tabs = [...root.querySelectorAll('[data-latest-tab]')];
    const hosts = tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
    const all = root.querySelector('[data-latest-all]');
    const loaded = new Set();
    const fy = tabs.findIndex((t) => t.hasAttribute('data-for-you'));
    const id = lastViewed();
    // For You with history: recommendations first (filled up with best sellers server side).
    const urlFor = (i) => (i === fy && id) ? '/recommendations/products?product_id=' + id + '&limit=10&section_id=home-latest-panel' : tabs[i].dataset.url;

    async function select(i, focus) {
      tabs.forEach((t, j) => {
        t.setAttribute('aria-selected', String(i === j));
        t.tabIndex = i === j ? 0 : -1;
        hosts[j].hidden = i !== j;
      });
      if (focus) tabs[i].focus();
      if (all) all.href = tabs[i].dataset.all;
      const bar = tabs[i].parentElement;
      bar.scrollTo({ left: tabs[i].offsetLeft - bar.clientWidth / 2 + tabs[i].offsetWidth / 2, behavior: 'smooth' });
      // Pinned pills (mobile): bring the new tab's grid back to its start.
      const top = root.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: window.scrollY + top, behavior: 'smooth' });
      if (!loaded.has(i)) {
        loaded.add(i);
        if (!(await load(hosts[i], urlFor(i)))) loaded.delete(i);
      }
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); select((i + d + tabs.length) % tabs.length, true); }
      });
    });

    // The page carries the first tab's first rows; the full grid loads as the section nears.
    const full = () => { if (!loaded.has(0)) { loaded.add(0); load(hosts[0], urlFor(0)).then((ok) => { if (!ok) loaded.delete(0); }); } };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); full(); } }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else full();
  }
  const run = () => document.querySelectorAll('[data-latest]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
